module.exports = {"primaryEndpoint":"api","secondaryEndpoint":"api","basicSubmitParams":{"agent_id":8,"client_source":"WWW","template":18,"requested_period":"mm","requested_time":1,"client_type":0},"kontomatikClient":"nau","kontomatikClientTest":"nau-test","min_amount":1000,"min_tenor":12,"default_amount":10000,"default_tenor":30,"tenor_sign":"m"}


//////////////////
// WEBPACK FOOTER
// ./src/conf/config.json
// module id = m8uw
// module chunks = 8